import React, { useEffect, useState } from "react";
import ViewPersonalinfomationStyles from "./ViewPersonalinfomation.styles";
import { Box } from "@mui/system";
import { Grid, Typography } from "@mui/material";
import CustomButton from "../../../../../global/components/CustomButton/CustomButton";
import { ReactComponent as PrintIcon } from "../../../../../assets/icons/print.svg";
import { ReactComponent as DownloadIcon } from "../../../../../assets/icons/download.svg";
import AvtarImg from "../../../../../assets/images/user-default.svg";
import { useAppSelector } from "../../../../../utils/hooks";
import { selectUserId } from "../../../../../redux/authSlice";
import customErrorHandler from "../../../../../utils/customErrorHandler";
import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";
import notifiers from "../../../../../global/constants/NotificationConstants";
import { getViewPerosnalDetails } from "./ViewPersonalinfomation.services";
import CustomLoader from "../../../../../global/components/CustomLoader/CustomLoader";

interface CustomProps {
  nextStep?: () => void | undefined;
}

const ViewPersonalinfomation = (props: CustomProps) => {
  const userIdFromRedux: any = useAppSelector(selectUserId);
  const [viewPersonalDetails, setViewPersonalDetails] = useState<any>();
  const [apiResponse, setApiResponse] = useState(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setApiResponse(true);
      const response = await getViewPerosnalDetails(userIdFromRedux);
      customErrorHandler(response);
      setViewPersonalDetails(response?.data);
      setApiResponse(false);
    } catch (error: any) {
      setApiResponse(false);
      openErrorNotification(
        isTruthy(error.message) ? error.message : notifiers.GENERIC_ERROR
      );
    }
  };

  const classes = ViewPersonalinfomationStyles;
  console.log(viewPersonalDetails, "viewPersonalDetails");
  return (
    <>
      <Box sx={classes.contentWrapper}>
        <Box sx={classes.pageInfoHeader}>
          <Typography sx={classes.Heading}>Personal Information</Typography>
          <Typography sx={classes.text}>
            Update your own information for the platform
          </Typography>
        </Box>
        <Grid container>
          <Grid item xs={12}>
            <Box sx={classes.avtarInfo}>
              <Box>
                <Typography sx={classes.detailsHeading}>
                  Personal Details
                </Typography>
                <Typography sx={classes.subHeading}>
                  Manage your personal information to use the platform
                </Typography>
              </Box>

              <Box mt={3}>
                <Box sx={classes.avtarImg}>
                  {viewPersonalDetails?.profile_image ? (
                    <img src={viewPersonalDetails?.profile_image} alt="img" />
                  ) : (
                    <img src={AvtarImg}></img>
                  )}
                </Box>
              </Box>
            </Box>
          </Grid>

          <Box sx={classes.profileDetails}>
            <Grid container rowSpacing={3}>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Name</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Work Email</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.email}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Phone Number</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.phone}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>WhatsApp Number</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.whatsapp}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Martial Status</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.martial_status}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Address 1</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.address1}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Address 2</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.address2}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Date Of Birth</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.dob}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>State</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.state_name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>City</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.city}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>Country</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.country_name}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography sx={classes.userLabal}>ZIP Code</Typography>
                <Typography sx={classes.userDetails}>
                  {viewPersonalDetails?.zipcode}
                </Typography>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={4}>
            <Box sx={classes.buttonWarapper}>
              <CustomButton
                label="Next"
                buttonType="primaryBtn"
                onClick={() => {
                  props.nextStep?.();
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      {apiResponse && <CustomLoader apiResponse={false} />}
    </>
  );
};

export default ViewPersonalinfomation;
